import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "./firebase";
import "./assest_design/Login.css";

import logo from "./assets/procode_za_logo.jpg";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      await signInWithEmailAndPassword(auth, email, password);
      setSuccess("Login successful.");

      // After successful login, go directly to ProCRM
      setTimeout(() => navigate("/procrm"), 400);
    } catch (err) {
      setError("Invalid email or password.");
    }
  };

  return (
    <div className="login-container">

      {/* LEFT PANEL */}
      <div className="login-left">
        <img 
          src="https://images.unsplash.com/photo-1502646434673-f914c2b11728?q=80&w=1170&auto=format&fit=crop"
          className="login-left-img"
          alt="ProCode Background"
        />

        <div className="login-left-overlay">
          <h2>ProCode ZA</h2>
          <p>Smart. Modern. African-built software.</p>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className="login-right">
        <div className="login-card">
          <img src={logo} alt="ProCode Logo" className="login-logo" />

          <p className="login-subtitle">Sign in to continue</p>

          {error && <p className="auth-message error">{error}</p>}
          {success && <p className="auth-message success">{success}</p>}

          <form onSubmit={handleLogin} className="login-form">
            
            <div className="auth-field">
              <label className="auth-label">Email Address</label>
              <input
                type="email"
                className="auth-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="auth-field">
              <label className="auth-label">Password</label>
              <input
                type="password"
                className="auth-input"
                placeholder="•••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="auth-button">Sign In</button>
          </form>
        </div>
      </div>

    </div>
  );
}

export default Login;